import React from "react";
import Label from "components/Input/Label/Label";
import Checkbox from "components/Input/Checkbox/Checkbox";
import s from "./CheckboxInput.module.scss";

const CheckboxInput = ({ label, oncheckFn, checked, divStyle, disabled }) => {
  return (
    <div className={s.checkboxContainer} style={divStyle}>
      <div className={s.checkboxBox}>
        <Checkbox disabled={disabled} oncheckFn={oncheckFn} checked={checked} />
      </div>
      <div className={s.checkboxLabel}>
        <Label label={label} />
      </div>
    </div>
  );
};

export default React.memo(CheckboxInput);
